/**
 * Para onde mandar quem entra no painel. O admin cai direto na tabela; os demais passam por
 * /dashboard, que decide pela relação da conta com eventos (utils/menuVisibility dashboardStartPath):
 * quem tem evento próprio ou delegado vai para a tabela, o atleta para a Arena de competições.
 */
export const dashboardHomePath = (role: string | undefined): string =>
  role === 'admin' ? '/dashboard/evento/tabela' : '/dashboard';
